import React, { VFC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { HOME, PLANS } from '../../../constants/routing';
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import OtetsutabiLogo from '../../../../shared/images/icons/logo.png';

const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${({ theme }) => theme.spacing(7.5, 2.5, 0)};
  text-align: center;
`;
const ImgWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
`;
const P = styled.p<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
  font-weight: bold;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 250px;
`;

const useStyles = makeStyles({
  buttonRoot: {
    width: '120px',
  },
});

interface Props {}
const Component: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { buttonRoot } = useStyles();
  return (
    <Wrapper theme={theme}>
      <ImgWrapper theme={theme}>
        <img src={OtetsutabiLogo} alt={t('error.imgAlt')} width={80} />
      </ImgWrapper>
      <P theme={theme}>{t('error.message')}</P>
      <ButtonWrapper>
        <Button
          color="primary"
          variant="outlined"
          component="a"
          href={HOME}
          classes={{ root: buttonRoot }}
        >
          {t('error.toTop')}
        </Button>
        <Button
          color="primary"
          variant="outlined"
          component="a"
          href={PLANS}
          classes={{ root: buttonRoot }}
        >
          {t('error.toPlans')}
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default Component;
